import { MODULES_MAP } from '../../constants';
import {
  setUser,
  setLoggedIn,
  setModules,
  setAllowedPaths,
} from '../reducers/userReducer';

export function setAdminDetails(adminDetails) {
  return async (dispatch) => {
    const tempModule = [];
    const tempPaths = [];
    adminDetails.roles.map((roleObj) => tempModule.push(...roleObj.modules));
    const adminModules = Array.from(new Set(tempModule));
    adminModules.map(
      (module) => MODULES_MAP[module] && tempPaths.push(...MODULES_MAP[module])
    );
    dispatch(setModules(adminModules));
    dispatch(setAllowedPaths(tempPaths));
    dispatch(setUser(adminDetails.user));
    dispatch(setLoggedIn(true));
  };
}
